import { SubroutineContext } from '@/context/SubroutineContext';
import { useContext } from 'react';

export const useSubroutine = () => useContext(SubroutineContext);
